import {useEffect, useRef, useState} from "react";
import Form, {ButtonItem, GroupItem, RequiredRule, SimpleItem} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {db} from "../../../../firebase/Firebase";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {FormContainer} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import './settings.css'
import {Button} from "devextreme-react/button";
import VerticalSpace from "../../../../palette/VerticalSpace";
import Alerts from "../../../../palette/Alerts";

const state = [{ID: 1, state: 'Activo'}, {ID: 2, state: 'Inactivo'}]

const typesPenalties = [{value: false, text: '% (Porcentaje)'}, {value: true, text: '$ (Valor)'}];

function CancellationFormEdit(props) {

    const {setTrigger, trigger, DataStore, setEdit, dataEdit, setVisibleGrid} = props

    const {companyName, idCompany,} = DataStore

    const [submitButton, setSubmitButton] = useState({
        ...buttonSuccess,
        text: 'Actualizar motivos',
        icon: 'far fa-edit'
    })
    const [load, setLoad] = useState(true)
    const [success, setSuccess] = useState(false)
    const [dataSource, setDataSource] = useState(null)

    const dxForm = useRef(null);
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        const {instance} = dxForm.current
        instance.resetValues()
        setDataSource({...dataEdit, penaltyValue: dataEdit.penaltyValue})
    }, [dataEdit])

    const renderCancelButton = () => {
        const {instance} = dxForm.current
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => {
                        instance.resetValues()
                        setDataSource(null)
                        setTrigger(!trigger)
                        setEdit(false)
                        setVisibleGrid(true)
                    }}/>
        )
    }

    const renderSuccess = () => {
        return (<Alerts severity="success" body={'Penalización actualizada exitosamente!'}/>
        )
    }

    const onValueChanged = (e) => {
        console.log(e.previousValue)
        if (e.previousValue !== null) {
            if(e.value){
                setDataSource({...dataSource, penaltyType: true, penaltyValue: null})
            }
            if(!e.value){
                setDataSource({...dataSource, penaltyType: false,  penaltyValue: null})
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setSubmitButton({...submitButton, disabled: true})
        setLoad(false)
        await db.collection(companyName).doc(idCompany).collection('cancellation').doc(dataEdit.docId)
            .set(dataSource).then(() => {
                setSuccess(true)
                setTrigger(!trigger)
                setTimeout(() => {
                    setEdit(false)
                    setVisibleGrid(true)
                    setLoad(true)
                    setSuccess(false)
                    setSubmitButton({...submitButton, disabled: false})
                }, 1700)
            }).catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                setLoad(true)
                setSubmitButton({...submitButton, disabled: false})
            })
    }

    console.log(dataSource)

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="routes-schedules-form">
                <HeaderPage icon={'far fa-list-alt'} text={'Actualizar rutas y horarios'} load={load}
                            textLoad={'Actualizando....'}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmit}>
                        <Form
                            ref={dxForm}
                            formData={dataSource}
                            readOnly={false}
                            showColonAfterLabel={true}
                            validationGroup="edit-schedule"
                        >
                            <GroupItem caption={'Datos'} colCount={1}>
                                <SimpleItem dataField="name" label={{text: 'Motivo de la cancelación'}}>
                                    <RequiredRule message="Ingrese un motivo"/>
                                </SimpleItem>
                            </GroupItem>
                            <GroupItem colCount={3}>
                                <SimpleItem dataField="penaltyType" label={{text: 'Tipos de penalización'}}
                                            editorType={'dxRadioGroup'}
                                            editorOptions={{
                                                dataSource: typesPenalties,
                                                valueExpr: 'value',
                                                layout: 'horizontal',
                                                displayExpr: 'text',
                                                onValueChanged: (e) => onValueChanged(e)
                                            }}/>
                                <SimpleItem dataField="penaltyValue" label={{text: 'Valor de penalizacion'}}
                                            editorType="dxNumberBox"
                                            editorOptions={{
                                                format: dataSource?.penaltyType ? "$ #,##0.##" : "#0%",
                                            }}>
                                    <RequiredRule message="Ingrese un valor"/>
                                </SimpleItem>
                                <SimpleItem dataField="state" label={{text: 'Estado'}} editorType="dxSelectBox"
                                            editorOptions={{
                                                dataSource: state,
                                                displayExpr: "state",
                                                valueExpr: "state",
                                                searchEnabled: true,
                                                placeholder: 'Seleccionar...'
                                            }}>
                                    <RequiredRule message="Seleccione el estado"/>
                                </SimpleItem>
                            </GroupItem>
                            <GroupItem colCount={1}>
                                {success &&
                                <SimpleItem render={renderSuccess}/>
                                }
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem render={renderCancelButton}/>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </GroupItem>
                        </Form>
                    </form>
                </FormContainer>
            </div>
        </>
    )

}

export default CancellationFormEdit